module.exports = __webpack_public_path__ + "media/truth_initiative_two/truth-logo-organge_316x86-a9eaf461.svg";